import {
  type DialogSizes,
  dialogSizes,
  type OverflowTypes,
  type ScrollTypes,
} from './utils';
import { css } from 'emotion';

export const dialog = (
  size: DialogSizes,
  scroll?: ScrollTypes,
  overflowY?: OverflowTypes
) => css`
  width: ${dialogSizes[size]}px;
  /* 96px is equal to the 48px top and bottom margin */
  max-height: ${scroll === 'body' ? 'none' : 'calc(100% - 96px)'};
  && {
    margin: 32px auto;
    overflow-y: ${overflowY || 'visible'}; /* necessary for datepicker */
    display: flex;
  }
`;

export const scrollBody = css``;

export const root = css`
  height: 100vh;
  overflow: auto;

  .${scrollBody} {
    /* Increasing specificity over .MuiDialog-container */
    height: auto;
  }
`;
